(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vifon-store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GM_LOADING = false, GM_READY = false, GM_CBS = [];

    function loadGoogleMaps(key, cb) {
      if (GM_READY && window.google && window.google.maps) { cb(); return; }
      GM_CBS.push(cb);
      if (GM_LOADING) return;
      GM_LOADING = true;
      window.__vifonGmapsInit = function () { GM_READY = true; GM_CBS.forEach(function (f) { f(); }); GM_CBS = []; };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
              '&libraries=places,marker&callback=__vifonGmapsInit&language=de&region=DE&loading=async';
      s.async = true;
      s.onerror = function () { GM_CBS.forEach(function (f) { f('error'); }); GM_CBS = []; };
      document.head.appendChild(s);
    }

    function loadClusterer(cb) {
      if (window.markerClusterer) { cb(); return; }
      var s = document.createElement('script');
      s.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
      s.async = true;
      s.onload = function () { cb(); };
      s.onerror = function () { cb(); }; // degrade gracefully to no clustering
      document.head.appendChild(s);
    }

    var MAP_STYLE = [
      { elementType: 'geometry', stylers: [{ color: '#f7f1e8' }] },
      { elementType: 'labels.text.fill', stylers: [{ color: '#6b5b4f' }] },
      { elementType: 'labels.text.stroke', stylers: [{ color: '#f7f1e8' }] },
      { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#d8c7b0' }] },
      { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#c9a86a' }, { weight: 1.1 }] },
      { featureType: 'poi', stylers: [{ visibility: 'off' }] },
      { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
      { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
      { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#f0dcb8' }] },
      { featureType: 'transit', stylers: [{ visibility: 'off' }] },
      { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cfe3e8' }] }
    ];

    function pinIcon(active) {
      var fill = active ? '#f7d876' : '#e62a36';
      var ring = active ? '#e62a36' : '#f7d876';
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="44" viewBox="0 0 34 44">' +
        '<path d="M17 43C7 30 2 22 2 15A15 15 0 0 1 32 15c0 7-5 15-15 28z" fill="' + fill + '" stroke="' + ring + '" stroke-width="2.5"/>' +
        '<circle cx="17" cy="15" r="5.5" fill="#fff"/></svg>';
      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    }

    function haversine(a, b, c, d) {
      var R = 6371, dLat = (c - a) * Math.PI / 180, dLng = (d - b) * Math.PI / 180;
      var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(a * Math.PI / 180) * Math.cos(c * Math.PI / 180) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[m]; }); }

    // Google calls this global when the API key is rejected (e.g. RefererNotAllowedMapError).
    // Without it the map goes dark and Places injects an error placeholder into the input.
    window.gm_authFailure = function () {
      document.querySelectorAll('[data-vifon-locator]').forEach(function (root) {
        var err = root.querySelector('[data-locator-maperror]');
        if (err) err.hidden = false;
        var input = root.querySelector('[data-locator-search]');
        if (input) {
          // Places disables the input and swaps the placeholder — restore a clean field
          var clean = input.cloneNode(false); // drops Places listeners/styling
          clean.disabled = false;
          clean.style.backgroundImage = 'none';
          clean.placeholder = input.getAttribute('data-placeholder') || clean.placeholder;
          input.parentNode.replaceChild(clean, input);
          // Degrade to a plain text filter over the list (name / city / postal)
          if (root.__setTextQuery) {
            clean.addEventListener('input', function () { root.__setTextQuery(clean.value); });
          }
        }
      });
    };

    function initLocator(root) {
      var key = root.getAttribute('data-gmaps-key');
      var url = root.getAttribute('data-stores-url');
      var mapEl = root.querySelector('[data-locator-map]');
      var listEl = root.querySelector('[data-locator-results]');
      var countEl = root.querySelector('[data-locator-count]');
      var emptyEl = root.querySelector('[data-locator-empty]');
      var errEl = root.querySelector('[data-locator-maperror]');
      var consentEl = root.querySelector('[data-locator-consent]');
      var consentBtn = root.querySelector('[data-locator-consent-btn]');
      var searchEl = root.querySelector('[data-locator-search]');
      var geoBtn = root.querySelector('[data-locator-geo]');
      var chips = root.querySelectorAll('[data-locator-filters] .vifon-locator__chip');

      var stores = [], filtered = [], markers = [], cluster = null, map = null, info = null, origin = null;
      var country = (root.getAttribute('data-default-country') || 'all');
      var activeIdx = -1;
      var textQuery = '';
      root.__setTextQuery = function (q) { textQuery = (q || '').trim().toLowerCase(); applyFilter(); };

      var CONSENT_KEY = 'vifon-map-consent';
      var mapLoading = false;

      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        stores = data.map(function (s, i) { s._i = i; return s; });
        // List, filters and text search all work with no map at all.
        bindTextFilter();
        applyFilter();
        if (!key) { showErr(); return; }
        // Load Google only on request (DSGVO), but remember the choice per session.
        var already = false;
        try { already = sessionStorage.getItem(CONSENT_KEY) === '1'; } catch (e) {}
        if (consentEl && !already) { consentEl.hidden = false; return; }
        activateMap();
      }).catch(function () { showErr(); });

      if (consentBtn) consentBtn.addEventListener('click', activateMap);

      function activateMap() {
        try { sessionStorage.setItem(CONSENT_KEY, '1'); } catch (e) {}
        if (consentEl) consentEl.hidden = true;
        if (map || mapLoading || !key) return;
        mapLoading = true;
        loadGoogleMaps(key, function (err) {
          mapLoading = false;
          if (err || !(window.google && window.google.maps)) { showErr(); return; }
          setupMap();
          loadClusterer(function () { buildMarkers(); applyFilter(); });
          setupAutocomplete();
        });
      }

      // Plain-text filtering over name / city / postal — works before (and after)
      // Google loads, so the search box is never dead.
      function bindTextFilter() {
        if (!searchEl || searchEl.__vifonTextBound) return;
        searchEl.__vifonTextBound = true;
        searchEl.addEventListener('input', function () { root.__setTextQuery(searchEl.value); });
      }

      function showErr() { if (errEl) errEl.hidden = false; if (consentEl) consentEl.hidden = true; }

      function setupMap() {
        map = new google.maps.Map(mapEl, {
          center: { lat: 50.5, lng: 10.5 }, zoom: 6,
          styles: MAP_STYLE, mapTypeControl: false, streetViewControl: false,
          fullscreenControl: true, gestureHandling: 'greedy',
          zoomControl: true, clickableIcons: false
        });
        info = new google.maps.InfoWindow();
      }

      function buildMarkers() {
        markers = stores.map(function (s) {
          var m = new google.maps.Marker({
            position: { lat: s.lat, lng: s.lng },
            icon: { url: pinIcon(false), scaledSize: new google.maps.Size(30, 39), anchor: new google.maps.Point(15, 39) },
            title: s.name
          });
          m._store = s;
          m.addListener('click', function () { selectStore(s._i, true); });
          return m;
        });
      }

      function directionsUrl(s) {
        return 'https://www.google.com/maps/dir/?api=1&destination=' +
          encodeURIComponent(s.street + ', ' + s.postal + ' ' + s.city + ', ' + (s.country === 'AT' ? 'Austria' : 'Germany'));
      }

      function applyFilter() {
        filtered = stores.filter(function (s) {
          if (country !== 'all' && s.country !== country) return false;
          if (!textQuery) return true;
          return (s.name + ' ' + s.city + ' ' + s.postal).toLowerCase().indexOf(textQuery) !== -1;
        });
        if (origin) {
          filtered.forEach(function (s) { s._d = haversine(origin.lat, origin.lng, s.lat, s.lng); });
          filtered.sort(function (a, b) { return a._d - b._d; });
        } else {
          filtered.sort(function (a, b) { return (a.country + a.city).localeCompare(b.country + b.city, 'de'); });
        }
        renderList();
        syncMarkers();
      }

      function syncMarkers() {
        if (!map) return;
        var visible = {};
        filtered.forEach(function (s) { visible[s._i] = true; });
        var shown = [];
        markers.forEach(function (m) {
          if (visible[m._store._i]) { shown.push(m); } else { m.setMap(null); }
        });
        if (cluster) { cluster.clearMarkers(); cluster.addMarkers(shown); }
        else { shown.forEach(function (m) { m.setMap(map); }); }

        if (window.markerClusterer && !cluster) {
          cluster = new markerClusterer.MarkerClusterer({ map: map, markers: shown, renderer: clusterRenderer() });
        }
        fitTo(shown);
      }

      function clusterRenderer() {
        return {
          render: function (o) {
            var count = o.count, pos = o.position;
            var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52"><circle cx="26" cy="26" r="22" fill="#e62a36" stroke="#f7d876" stroke-width="3"/></svg>';
            return new google.maps.Marker({
              position: pos,
              icon: { url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg), scaledSize: new google.maps.Size(52, 52), anchor: new google.maps.Point(26, 26) },
              label: { text: String(count), color: '#fff', fontSize: '13px', fontWeight: '700' },
              zIndex: 1000 + count
            });
          }
        };
      }

      function fitTo(ms) {
        if (!map || !ms.length) return;
        if (origin) {
          map.setCenter({ lat: origin.lat, lng: origin.lng });
          map.setZoom(ms.length > 1 ? 10 : 13);
          return;
        }
        var b = new google.maps.LatLngBounds();
        ms.forEach(function (m) { b.extend(m.getPosition()); });
        map.fitBounds(b, 40);
      }

      function renderList() {
        listEl.innerHTML = '';
        if (countEl) {
          countEl.textContent = filtered.length + (filtered.length === 1 ? ' Standort' : ' Standorte') + (origin ? ' – nach Entfernung' : '');
        }
        if (emptyEl) emptyEl.hidden = filtered.length > 0;
        var frag = document.createDocumentFragment();
        filtered.slice(0, 300).forEach(function (s) {
          var li = document.createElement('li');
          var dist = (s._d != null && origin) ? '<span class="vifon-locator__dist">' + (s._d < 10 ? s._d.toFixed(1) : Math.round(s._d)) + ' km</span>' : '';
          li.innerHTML =
            '<button type="button" class="vifon-locator__item" data-i="' + s._i + '">' +
              '<span class="vifon-locator__itemtop"><span class="vifon-locator__name">' + esc(s.name) + '</span>' + dist + '</span>' +
              '<span class="vifon-locator__addr">' + esc(s.street) + '<br>' + esc(s.postal) + ' ' + esc(s.city) + '</span>' +
              (s.brand ? '<span class="vifon-locator__badge">' + esc(s.brand) + '</span>' : '') +
              '<br><a class="vifon-locator__route" href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Route planen →</a>' +
            '</button>';
          frag.appendChild(li);
        });
        listEl.appendChild(frag);
        listEl.querySelectorAll('.vifon-locator__item').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            if (e.target.closest('.vifon-locator__route')) return;
            selectStore(parseInt(btn.getAttribute('data-i'), 10), true);
          });
        });
      }

      function selectStore(idx, fromUser) {
        activeIdx = idx;
        var s = stores[idx];
        listEl.querySelectorAll('.vifon-locator__item').forEach(function (b) {
          var on = parseInt(b.getAttribute('data-i'), 10) === idx;
          b.classList.toggle('is-active', on);
          if (on && fromUser) b.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
        if (map) {
          map.panTo({ lat: s.lat, lng: s.lng });
          if (map.getZoom() < 12) map.setZoom(13);
          if (info) {
            info.setContent('<div class="vifon-iw"><div class="vifon-iw__name">' + esc(s.name) + '</div>' +
              '<div class="vifon-iw__addr">' + esc(s.street) + '<br>' + esc(s.postal) + ' ' + esc(s.city) + '</div>' +
              '<a class="vifon-iw__route" href="' + directionsUrl(s) + '" target="_blank" rel="noopener">Route planen →</a></div>');
            var mk = markers[stores.indexOf(s)] || markers.find(function (m) { return m._store._i === idx; });
            if (mk) info.open(map, mk);
          }
        }
      }

      function setOrigin(lat, lng) { origin = { lat: lat, lng: lng }; applyFilter(); }

      function setupAutocomplete() {
        if (!(google.maps.places && google.maps.places.Autocomplete)) return;
        var ac = new google.maps.places.Autocomplete(searchEl, {
          fields: ['geometry'], componentRestrictions: { country: ['de', 'at'] }
        });
        ac.addListener('place_changed', function () {
          var p = ac.getPlace();
          if (p && p.geometry && p.geometry.location) {
            setOrigin(p.geometry.location.lat(), p.geometry.location.lng());
          }
        });
      }

      if (geoBtn) geoBtn.addEventListener('click', function () {
        if (!navigator.geolocation) return;
        geoBtn.disabled = true;
        navigator.geolocation.getCurrentPosition(
          function (pos) { geoBtn.disabled = false; setOrigin(pos.coords.latitude, pos.coords.longitude); },
          function () { geoBtn.disabled = false; }
        );
      });

      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { x.classList.remove('is-active'); });
          c.classList.add('is-active');
          country = c.getAttribute('data-country');
          applyFilter();
        });
      });

      // Enter in search without picking a suggestion → do nothing destructive
      searchEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }

    function boot() {
      document.querySelectorAll('[data-vifon-locator]').forEach(function (el) {
        if (el.__vifonInit) return; el.__vifonInit = true; initLocator(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
